module.exports = __webpack_public_path__ + "static/media/extractive_services_law_orange.db749fd9.svg";